import logo from "../../../assets/doctio-logo.svg";
import { NavLink } from "react-router-dom";
import MobileMenu from "../MobileMenu/MobileMenu";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [sticky, setSticky] = useState("relative");
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener("scroll", stickNavbar);

    return () => {
      window.removeEventListener("scroll", stickNavbar);
    };
  }, []);

  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      windowHeight > 1
        ? setSticky("sticky top-0 w-full z-50 drop-shadow-md")
        : setSticky("relative");
    }
  };

  return (
    <nav className={`bg-doctio-beige h-24 md:h-36 border-gray-200 ${sticky}`}>
      <div
        className={`flex flex-wrap items-center relative justify-between mx-auto md:pt-10 container`}
      >
        <NavLink to="/" className="flex mt-6 md:ml-0 md:mt-0 items-center">
          <img
            src={logo}
            className="max-w-[120px] md:max-w-none mr-3"
            alt="Doctio logo"
          />
        </NavLink>

        <div
          onClick={() => setMobileMenu(!mobileMenu)}
          className="mr-4 mt-4 lg:hidden cursor-pointer"
        >
          <div className="HAMBURGER-ICON space-y-3">
            <span className="block h-1 w-12 animate-pulse bg-doctio-green"></span>
            <span className="block h-1 w-12 animate-pulse bg-doctio-green"></span>
            <span className="block h-1 w-12 animate-pulse bg-doctio-green"></span>
          </div>
        </div>

        <div className="navbar-container-right hidden lg:flex">
          <div className="flex items-center ml-28 md:order-2">
            <NavLink
              to="/login"
              className="tracking-[1.3px] leading-4 uppercase tracking-wide font-medium text-dxs mr-10"
            >
              Login
            </NavLink>
            <button
              type="button"
              onClick={() => navigate("/signup")}
              className="text-white transition-colors w-56 duration-300 ease-in-out font-bold rounded-full bg-doctio-green hover:bg-white hover:text-doctio-green hover:shadow-md focus:ring-4 focus:outline-none px-4 py-2 text-center mr-3 md:mr-0"
            >
              Opret bruger
            </button>
            <button
              data-collapse-toggle="navbar-sticky"
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-dsm text-gray-700 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
              aria-controls="navbar-sticky"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
          </div>
          <div
            className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
            id="navbar-sticky"
          >
            <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg  md:flex-row md:space-x-16 md:mt-0 md:border-0 ">
              <li>
                <NavLink
                  to="/"
                  className={
                    "block py-2 pl-3 pr-4 text-doctio-dark font-medium md:p-0 rounded"
                  }
                  aria-current="page"
                >
                  Forside
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/priser"
                  className={
                    "block py-2 pl-3 pr-4 text-doctio-dark font-medium md:p-0 rounded"
                  }
                >
                  Priser
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/tutorials"
                  className={
                    "block py-2 pl-3 pr-4 text-doctio-dark font-medium md:p-0 rounded"
                  }
                >
                  Tutorials
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/team"
                  className={
                    "block py-2 pl-3 pr-4 text-doctio-dark font-medium md:p-0 rounded"
                  }
                >
                  Teamet bag
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/kontakt"
                  className={
                    "block py-2 pl-3 pr-4 text-doctio-dark font-medium md:p-0 rounded"
                  }
                >
                  Kontakt
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        <MobileMenu open={mobileMenu} setOpen={setMobileMenu} />
      </div>
    </nav>
  );
}

export default Navbar;
